import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import administrators from './administrators'
import applications from './applications'
import attachments from './attachments'
import campaigns from './campaigns'
import candidates from './candidates'
import clients from './clients'
import disciplines from './disciplines'
import documentBundles from './document_bundles'
import eligibilities from './eligibilities'
import experiences from './experiences'
import experience_organizations from './experience_organizations'
import flags from './flags'
import institutions from './institutions'
import invites from './invites'
import jobs from './jobs'
import opportunities from './opportunities'
import organizations from './organizations'
import profileQualifications from './profile_qualifications'
import profiles from './profiles'
import qualificationTypes from './qualification_types'
import qualifications from './qualifications'
import referrals from './referrals'
import tools from './tools'

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // Each of these routes are loaded asynchronously, when a user first
    // navigates to each corresponding endpoint. The route will load once into
    // memory, the first time it's called, and no more on future calls. This
    // behavior can be observed on the network tab of your browser dev tools.
    // component: () => import(/* webpackChunkName: "" */ "@/views/.vue"),
    {
      path: '/404',
      component: () => import(/* webpackChunkName: "not-found" */ '@/views/NotFound.vue'),
    },
    {
      path: '/dashboard',
      meta: { auth: 'administrator' },
      component: () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard.vue'),
    },
    ...administrators,
    ...applications,
    ...attachments,
    ...campaigns,
    ...candidates,
    ...clients,
    ...disciplines,
    ...documentBundles,
    ...eligibilities,
    ...experiences,
    ...experience_organizations,
    ...flags,
    ...institutions,
    ...invites,
    ...jobs,
    ...opportunities,
    ...organizations,
    ...profileQualifications,
    ...profiles,
    ...qualificationTypes,
    ...qualifications,
    ...referrals,
    ...tools,
    {
      path: '/analytics',
      meta: { auth: 'administrator' },
      component: () => import(/* webpackChunkName: "analytics" */ '@/views/Analytics.vue'),
    },
    {
      path: '/demographics',
      meta: { auth: 'administrator' },
      component: () => import(/* webpackChunkName: "demographics" */ '@/views/Demographics.vue'),
    },
    {
      path: '/reports',
      meta: { auth: 'administrator' },
      component: () => import(/* webpackChunkName: "reports" */ '@/views/reports/List.vue'),
    },
    {
      path: '/api',
      meta: { auth: 'administrator' },
      component: () => import(/* webpackChunkName: "api-explorer" */ '@/views/ApiExplorer.vue'),
    },
    {
      path: '/',
      component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
    },
    {
      path: '/style',
      meta: { auth: 'administrator' },
      component: () => import(/* webpackChunkName: "style-guide" */ '@/views/StyleGuide.vue'),
    },
    // Render everything else as a 404
    {
      path: '*',
      component: () => import(/* webpackChunkName: "not-found" */ '@/views/NotFound.vue'),
    },
  ],
})

// Authentication Navigation Guard
// see: https://router.vuejs.org/en/advanced/navigation-guards.html
router.beforeEach((to, from, next) => {
  // Stop navigations when staying on the same route (except homepage)
  if (to.path !== '/' && to.path === from.path) {
    window.history.replaceState({}, null, to.fullPath)
    return false
  }

  // Check for presence of rules
  if (to.meta && to.meta.auth != null) {
    const auth = to.meta.auth
    // Pull role from the token since the state may not have it yet
    const payload = router.app.$auth.getPayload()
    const role = payload && payload.role

    /* { auth: true } // Must be logged in */
    if (auth === true) {
      if (role) next()
      if (role === null) next('/')
    }

    /* { auth: false } // Must not be logged in */
    if (auth === false) {
      if (role) next('/dashboard')
      if (role === null) next()
    }

    /* { auth: 'admin' } // Must be logged in as an admin */
    if (typeof auth === 'string') {
      if (role === null) next('/')
      if (role != auth) next('/dashboard')
      if (role === auth) next()
    }

    /* TODO: { auth: ['admin', 'client'] } // Must be logged in as an admin or client */
  } else {
    // No rules – sshh, just let it happen
    next()
  }
})

export default router
